// Designer-specified colors

const PRIMARY_BLUE = '#578BCD';
const ACCENT_BLUE = '#315B8E';
const PRIMARY_GRAY = '#8D9393';
const PURPLE = '#780082';
const IRON = '#8C8C8C';
const CHARCOAL = '#191919';
const VALIDATION = '#40BF9F';
const ERROR = '#DA4453';
const ERROR_DARK = '#BF0000';
const WARNING = '#DB750B';
const SECONDARY_CTA = '#FFA000';
const CORAL = '#E6644B';
const LIGHT_MARIGOLD = '#F7BE5E';
const NAVY = '#0528A0';
const SLATE = '#404040';
const SKY = '#006DFF';
const CLOUD = '#F3F5FB';
const MIST = '#F2F2F2';
const GRAY = '#CACACA';
const DARK_GRAY = '#BDBDBD';
const PEWTER = '#9F9F9F';
const BACKGROUND_BLUE = '#0528A0';
const BLACK = '#000000';
const GREEN = '#258000';
const BACKGROUND_GRAY = '#F9F9F9';
const YELLOW = '#F2C94C';
const HAZE = '#F9F9F9';

const PRIMARY_TEXT = '#151E34';
const SECONDARY_TEXT = '#4e606e';
const TERTIARY_TEXT = '#707070';
const WHITE_TEXT = '#FFFFFF';
const DISCLAIMER_TEXT = '#6D6D6D';
const DESCRIPTION_TEXT = '#545454';

const SECTION_BACKGROUND = '#F7F7F7';
const SITE_HEADER_BACKGROUND = '#F2F2F2';
const FIELD_BACKGROUND = '#EAEAEA';
const SHADOWS = '#B6BCC1';

// Our colors

const BOX_SHADOW = '#0000003b';
const WHITE_BACKGROUND = '#FFFFFF';
const UPLOAD_GRAY = '#BFBFBF';
const ALMOST_WHITE = '#FEFEFE';
const GRAY_BACKGROUND = '#FCFCFC';
const ALMOST_GRAY = '#F5F5F5';
const SHADOW_GRAY = '#818A91';
const BOX_BACKGROUND = '#EDEDED';
const DIVIDER_GRAY = '#AEAEAE';
const FOOTER_GRAY = '#878889';

export {
  ACCENT_BLUE,
  ALMOST_GRAY,
  ALMOST_WHITE,
  BACKGROUND_BLUE,
  BACKGROUND_GRAY,
  BLACK,
  BOX_BACKGROUND,
  BOX_SHADOW,
  CHARCOAL,
  CLOUD,
  CORAL,
  DARK_GRAY,
  DESCRIPTION_TEXT,
  DISCLAIMER_TEXT,
  DIVIDER_GRAY,
  ERROR,
  ERROR_DARK,
  FIELD_BACKGROUND,
  GRAY,
  GRAY_BACKGROUND,
  GREEN,
  IRON,
  LIGHT_MARIGOLD,
  MIST,
  NAVY,
  PEWTER,
  PRIMARY_BLUE,
  PRIMARY_GRAY,
  PRIMARY_TEXT,
  PURPLE,
  SECONDARY_CTA,
  SECONDARY_TEXT,
  SECTION_BACKGROUND,
  SHADOWS,
  SHADOW_GRAY,
  SITE_HEADER_BACKGROUND,
  SKY,
  SLATE,
  TERTIARY_TEXT,
  UPLOAD_GRAY,
  VALIDATION,
  WARNING,
  WHITE_BACKGROUND,
  WHITE_TEXT,
  YELLOW,
  HAZE,
  FOOTER_GRAY
};
